<template>
    <div class="map-single">
        <div id="mapSingle" ref="map"></div>
    </div>
</template>

<script>
export default {
    name: "GoogleMapSingle",

    props: ["location"],

    data: function() {
        return {
            map: null,
            mapCenter: {
                lat: this.location.lat ? parseFloat(this.location.lat) : 0,
                lng: this.location.lng ? parseFloat(this.location.lng) : 0,
            },
        };
    },

    mounted() {
        this.initMap();
    },

    methods: {
        initMap: function() {
            this.map = new google.maps.Map(
                document.getElementById("mapSingle"),
                {
                    center: this.mapCenter,
                    zoom: 13,
                    maxZoom: 20,
                    minZoom: 3,
                    zoomControl: false,
                    fullscreenControl: false,
                    streetViewControl: false,
                    mapTypeControl: false,
                },
            );
            this.setMarker();
        },
        setMarker: function() {
            const map = this.map;
            const position = this.mapCenter;
            const marker = new google.maps.Marker({
                position,
                map,
                icon: `${this.$store.state.appUrl}/img/pwa/login/marker.png`,
                label: {
                    text: "1",
                    color: "#FFF",
                },
            });
        },
    },
};
</script>
